import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import moment from 'moment';
import PackageItinerary from '../PackageItinerary/PackageItinerary';
import { hasLodgingForPackage } from '../../util/package';
import { daysAdded } from '../../util/dates';
import { ReactComponent as DiamondLight } from '../../assets/icons/diamond-light.svg';
import css from './InquiryItinerary.module.css';
import { HUNT_ACTIVITY } from '../../marketplace-custom-config';

const InquiryItinerary = ({ listing, formValues }) => {
  const activity = get(formValues, 'activity', null);
  const partySize = get(formValues, 'partySize', 1);
  const bookingDates = get(formValues, 'bookingDates', {});

  const { startDate, endDate, startLodgingDate } = bookingDates;
  const selectedPackage = get(formValues, 'selectedPackage', null);

  // Calculate dynamic hasLodging similar to InquiryWizardStepSummary
  const hasLodging = hasLodgingForPackage(selectedPackage);
  const includeLodgings = formValues?.lodgingAddons?.length > 0 || hasLodging;
  const tripLength = startDate && endDate ? daysAdded(startDate, endDate) : 0;
  const dynamicHasLodging = includeLodgings && tripLength > 1;

  const gameUnit =
    activity === HUNT_ACTIVITY
      ? get(listing, `attributes.publicData.activities.${activity}.game`, null)
      : null;

  // Only render if we have the required dates
  if (!startDate || !endDate) {
    return null;
  }

  return (
    <>
      <PackageItinerary
        activity={activity}
        listing={listing}
        startDate={moment(startDate).format('YYYY-MM-DD')}
        endDate={moment(endDate).format('YYYY-MM-DD')}
        hasLodging={dynamicHasLodging}
        bookingGuestSize={partySize}
        isProvider={false}
        startLodgingDate={startLodgingDate ? moment(startLodgingDate).format('YYYY-MM-DD') : null}
      />

      {gameUnit && (
        <div className={css.iconSectionWrapper}>
          <DiamondLight className={css.icon} />

          <div className={css.iconSection}>
            <div className={css.iconSectionLabel}>
              <FormattedMessage id="InquiryWizard.gameUnit" />
            </div>
            <div className={css.iconSectionValue}>{gameUnit}</div>
          </div>
        </div>
      )}
    </>
  );
};

InquiryItinerary.propTypes = {
  listing: PropTypes.object.isRequired,
  formValues: PropTypes.object.isRequired,
};

export default InquiryItinerary;
